export const GET_SUGGESTED_ITEM = "GET_SUGGESTED_ITEM";
export const ADD_TO_WATCHLIST = "ADD_TO_WATCHLIST";
export const REMOVE_FROM_WATCHLIST = "REMOVE_FROM_WATCHLIST";
export const POST_KIT = "POST_KIT";
export const SWITCH_SELL_FORM = "SWITCH_SELL_FORM";
export const SELL_SET_KIT_ID = "SELL_SET_KIT_ID";
export const SELL_GET_KIT = "SELL_GET_KIT";
export const ADD_MEDIA = "ADD_MEDIA";
export const REMOVE_MEDIA = "REMOVE_MEDIA";
export const ADD_FILE = "ADD_FILE";
export const REMOVE_FILE = "REMOVE_FILE";
export const SELL_SET_THUMBNAIL = "SELL_SET_THUMBNAIL";
export const SELL_SET_RFP_ID = "SELL_SET_RFP_ID";
export const SET_FORM_2_SCHEMA = "SET_FORM_2_SCHEMA";
export const SELL_SET_EDIT_MODE = "SELL_SET_EDIT_MODE";
export const GET_CATEGORY_SPECS = "GET_CATEGORY_SPECS";
export const SET_QUOTED_RFP_ID = "SET_QUOTED_RFP_ID";
export const SELL_SET_KIT_FROM_SEARCH = "SELL_SET_KIT_FROM_SEARCH";
export const GET_CATEGORY_BY_ID = "GET_CATEGORY_BY_ID";
export const GET_MATCHING_RFPS = "GET_MATCHING_RFPS";
export const SELL_AI_CHAT = "SELL_AI_CHAT";
export const SELL_AI_CHAT_STATUS = "SELL_AI_CHAT_STATUS";
export const SUGGEST_KIT_ACCESSORIES = "SUGGEST_KIT_ACCESSORIES";
export const SELL_AI_CHAT_PROGRESS = "SELL_AI_CHAT_PROGRESS";
